import { createSelector } from '@reduxjs/toolkit'
import { RootState } from '@store/store'

const getRoot = (state: RootState) => state.genre

export const genreListData = createSelector(getRoot, (state) => state.list)
